/** global gsap */
import { setCookie, getCookie } from "../cookies";

export default class Preloader {
    constructor() {
        this.preloader     = document.getElementById('preloader');
        if (!this.preloader) return;
        this.image         = this.preloader.querySelector('.image-wrapper');
        this.digits        = this.preloader.querySelectorAll('.digit');
        this.digitsWrapper = this.preloader.querySelector('.digits');
        this.mask          = this.preloader.querySelector('.mask');
        this.startValue    = parseInt(this.digitsWrapper.dataset.start);
        this.endValue      = parseInt(this.digitsWrapper.dataset.end);

        // console.log(`starting from ${this.startValue}`);
        // console.log(`ending to ${this.endValue}`);

        if (getCookie('PRELOAD_COMPLETE') && window.location.href.indexOf("?debug") <= -1 ) {
            this.preloader.classList.add('disapp');
            window.dispatchEvent(new Event('preloader.completed'));
            return;
        }
        
        this.events();
    }
    
    init() {
        document.body.classList.add('has-preloader');
        document.body.classList.add('overflow-hidden');

        const current_year = new Date().getFullYear();
        this.tl            = gsap.timeline({onComplete: () => this.onPreloaderComplete.bind(this)()});
        // this.tl            = gsap.timeline();

        // this.digits.forEach((d, idx) => d.textContent = current_year.toString()[idx]);
        this.digits.forEach((d, idx) => d.textContent = this.startValue.toString()[idx]);

        this.tl
            .to(this.image, {duration: 0.8, opacity: 0.8, ease: "power4.in"}) // logo fade
            .to(this.digits, {duration: 0.65, opacity: 1, y: 0, stagger: 0.15}) // digits up
            .add(gsap.delayedCall(0.4, () => {
                    this.animateValue(this.digitsWrapper, this.startValue, this.endValue, this.startValue);
                    // this.preloader.classList.add("loaded");
                }
            ))
            .to(this.mask, {duration: 0.4, y: 0, ease: "power3.out"}, '+=3') // mask up
            .to(this.preloader, { duration: 0.4, y: "-100vh", ease: "power3.out"}, "+=0.5") // preloader up
    }

    onPreloaderComplete() {
        // console.log('preloader completed!');
        document.body.classList.remove('has-preloader');
        document.body.classList.remove('overflow-hidden');
        this.preloader.classList.add('disapp');
        setCookie('PRELOAD_COMPLETE', '1', 7); // 7 days
        window.dispatchEvent(new Event('preloader.completed'));
    }

    animateValue(element, current_value, start_value, end_value) {
        let r = null;
        window.requestAnimationFrame((function o(a) {
                r || (r = a);
                let l = Math.min((a - r) / end_value, 1);
                // if (start_value > end_value) {
                    element.innerHTML = Math.floor(l * (start_value - current_value) + current_value);
                // } else {
                // }
                l < 1 && window.requestAnimationFrame(o);
            }
        ));
    }

    events() {
        window.addEventListener('load', this.init.bind(this), false);
    }
}